import React from "react";
import AdminLayerBlueprint from "components/blueprints/AdminLayerBlueprint";
import AdminOrdersTableHeader from "./AdminOrdersTableHeader";
import AdminOrdersPageTable from "./AdminOrdersPageTable";

function AdminOrdersPage() {
  return (
    <section className="bg-gray-100" style={{ minHeight: "calc(100vh - 60px)" }}>
      <div className="container mx-auto">
        <div className="bg-white pt-2 pb-6 shadow-md blur-2 text-opacity-15 spread-0 mb-[30px]">
          <AdminOrdersTableHeader />
          <AdminOrdersPageTable />
        </div>
      </div>
    </section>
  );
}

export default AdminLayerBlueprint(AdminOrdersPage);
